import { IApplicationState } from '../../types/redux';
import { IDeveloperV2 } from '../../types/developerV2/developer';
import { IReview } from '../../types/developerV2/review';

export const getReviews = (state: IApplicationState): IReview[] => (state.developerV2 as IDeveloperV2).reviews;
